import { render, staticRenderFns } from "./SpecSheetDownload.vue?vue&type=template&id=1b662065&scoped=true&"
import script from "./SpecSheetDownload.vue?vue&type=script&lang=js&"
export * from "./SpecSheetDownload.vue?vue&type=script&lang=js&"
import style0 from "./SpecSheetDownload.vue?vue&type=style&index=0&id=1b662065&prod&lang=scss&scoped=true&"
import style1 from "./SpecSheetDownload.vue?vue&type=style&index=1&id=1b662065&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b662065",
  null
  
)

export default component.exports